import { render, staticRenderFns } from "./index2.vue?vue&type=template&id=41af1783&scoped=true&"
import script from "./index2.vue?vue&type=script&lang=js&"
export * from "./index2.vue?vue&type=script&lang=js&"
import style0 from "./index2.vue?vue&type=style&index=0&id=41af1783&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41af1783",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/skip/index2.vue
// module id = null
// module chunks = 